"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceCondition = void 0;
const PropertyCondition_1 = require("./PropertyCondition");
class ChoiceCondition extends PropertyCondition_1.PropertyCondition {
    constructor(property, choices) {
        super(property);
        this.choices = choices;
    }
    isFulfilled(value) {
        const propertyResult = super.checkProperty(value);
        if (propertyResult.isFinal) {
            return propertyResult.result;
        }
        if (this.choices.includes(value[this.property])) {
            return { fulfilled: true };
        }
        const explanation = "is none of " + this.choices.join(",");
        return { fulfilled: false, reasons: [{ path: this.property, value: value[this.property], explanation }] };
    }
}
exports.ChoiceCondition = ChoiceCondition;
//# sourceMappingURL=ChoiceCondition.js.map